import styled from "styled-components";

export const NavbarActions = styled.div`
    display: flex;
    gap: 0.5rem;
`;
